import "./forgotPasswordStyles.css";

import dotsBottom from "../../assets/login-dots-bottom.svg";
import dotsTop from "../../assets/login-dots-top.svg";
import vectorArt from "../../assets/login-vector-art.png";
import logo from "../../assets/top-nav-logo.svg";
import { useEffect, useState } from "react";
import { resetPasswordValidation } from "../../request-handlers/validation/request-validation";
import { useDispatch } from "react-redux";
import { loginAttempt } from "../features/user/user";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import Button from '../design/Button'
import { CustomInput } from '../design/components/customComponents'

const API_BASE_URL = process.env.REACT_APP_BETA;
function ForgotPasswordReset() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    
	const [email, setEmail] = useState({value: "", error: null});
    const [isDisabled, setIsDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const handleEmailChange = e => setEmail(prev => ({...prev, value: e.target.value}))

    const  handleSubmit = e => {
        e.preventDefault()
        setIsLoading(true);
        fetch(API_BASE_URL + '/api/v1/auth/send-code/', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({email: email.value, source: 'reset'})
        })
		.then(res => {
            if(res?.status === 500) throw new Error('Server error please try again or if issue persists contact FreJun')
            return res?.json()  
        }).then(res => {
            if(!res?.success) throw new Error(res?.message || `Error occurred while sending reset password to ${email.value}`)
			enqueueSnackbar(res?.message + " to " + email.value || `Sent reset code to ${email.value}`, { variant: "success"})
			
            dispatch(loginAttempt({email: email.value, password: ''}))
            navigate('/forgot-password/verification', {replace: true});
        }).catch(err => enqueueSnackbar(err?.message, { variant: "error"}))
        .finally(() => {
            setIsLoading(false);
        })
    }

    useEffect(()=>{
        if(resetPasswordValidation({email: email.value}).isValid){
            setIsDisabled(false);
        }
        else{
            setIsDisabled(true)
        }
    }, [email])

    return(
		<div className='signup-container'>
			<div className='signup-art'>
            <a href="https://frejun.com/" target="_blank" rel="noopener noreferrer"> <img src={logo} alt="Logo" /></a>
			<img src={ dotsTop } alt=""/>
			<img style={{width: "60vmin"}} src={ vectorArt } alt=""/>
			<img src={ dotsBottom } alt=""/>
			<p className='regular-font t5'>Simplify and Automate<br/>Your Calling Process</p>
			</div>
			<div className='forgot-password-container'>
				<p className='title medium-font t5'>Forgot password</p>
                <div>
                    <p className='t7 regular-font'>Enter your email to receive a verification code for password reset</p>
                    <form onSubmit={handleSubmit}>
                        <CustomInput 
                            label="Email" 
                            value={email} 
                            handleChange={handleEmailChange} 
                            type="email" 
                            name="email" 
                            handleFocus={() => null} 
                            style={{ width: '100%' }}
                        />
                        <div className='forgot-password--btn-container'>
                            <Button
                                buttonText="Send verification code"
                                onClick={handleSubmit}
                                disabled={isDisabled}
                                isLoading={isLoading}
                                styleOverride={{ width: '100%', height: '40px'}}
                                spanStyles={{ width: '100%' }}
                                variant="contained"
                                hierarchy="green"
                                // className="forgot-password-btn"
                                // id='reset-password-button'
                            />
                            <a href='/login' className='to-login regular-font t7 color-green to-sign-up'>Return to login</a>
                        </div>
                    </form>
                </div>
			</div>
		</div>
    )
}
export default ForgotPasswordReset;
